import React from "react";
import { Switch } from "react-router-dom";
import AppRoute from "./AppRoute";
import { PATHS } from "@config/constants";
import { ROUTES } from "./_routes";
import MainLayout from "@layouts/MainLayout";
import HomePage from "@pages/HomePage";

const Routes = () => {
  return (
    <Switch>
      {ROUTES.map((route, i) => {
        return <AppRoute key={`app-router-${i}`} {...route} />;
      })}
      <AppRoute
        path={PATHS.UNDEFINED_PAGE}
        layout={MainLayout}
        component={HomePage}
        exact={true}
        private={false}
      />
    </Switch>
  );
};

export default Routes;
